export const AUTH_STORAGE_KEY = 'ttsds-user'

let syncedAuthData = {
  isLoggedIn: false,
  accessToken: null,
  refreshToken: null,
  idToken: null,
  user: {}
}

if(sessionStorage.getItem(AUTH_STORAGE_KEY)) {
  syncedAuthData = JSON.parse(sessionStorage.getItem(AUTH_STORAGE_KEY));
}

const state = Object.assign(syncedAuthData);

const actions = {
  UPDATE_AUTH ({commit}, data) {
    commit('UPDATE_AUTH', data);
  },
  ASSIGN_ADMIN ({commit, state}, data) {
    if(state.user.email === data.email) {
      commit('ASSIGN_ADMIN');
    }
  },
  SET_USER_AUTH ({commit}, user) {
    commit('SET_USER_AUTH', user);
  },
  UPDATE_AUTH_USER ({commit}, user) {
    commit('SET_USER_AUTH', user);
  },
  CLEAR_AUTH ({commit}) {
    commit('CLEAR_AUTH');
  }
}

const mutations = {
  UPDATE_AUTH (state, auth) {
    state = {...state, ...auth}
  },
  SET_USER_AUTH (state, user) {
    state.user = {...state.user, ...user}
  },
  CLEAR_AUTH (state) {
    state.isLoggedIn = false;
    state.accessToken = null;
    state.refreshToken = null;
    state.idToken = null;
    state.user = {}
  }
}

const getters = {
  // getState(state) {
  //   return state;
  // },
  isLoggedIn(state) {
    return state.isLoggedIn;
  },
  accessToken(state) {
    return state.accessToken;
  },
  refreshToken(state) {
    return state.refreshToken;
  },
  idToken(state) {
    return state.idToken;
  },
  authUser(state) {
    return state.user;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
